import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (username === 'demo' && password === 'demo') {
      onLogin(username);
    } else {
      setError('Invalid credentials. Please use demo/demo');
      setTimeout(() => setError(''), 3000);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background"></div>

      <div className="login-content">
        <div className="login-box">
          <div className="login-header">
            <img src="/logo-spheroid.png" alt="SPHEROID" className="login-logo" />
            <h1>SPHEROID</h1>
            <p className="login-motto">Earth Observation Monitoring Platform</p>
            <p className="login-subtitle">Observability and performance monitoring for Earth Observation data pipelines and services.</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">
                <FontAwesomeIcon icon={faUser} />
                <span>Username</span>
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                autoComplete="username"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">
                <FontAwesomeIcon icon={faLock} />
                <span>Password</span>
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
            </div>

            {error && (
              <div className="login-error">
                {error}
              </div>
            )}

            <button type="submit" className="login-button">
              Sign In
            </button>

            <div className="login-hint">
              Demo credentials: <strong>demo / demo</strong>
            </div>
          </form>
        </div>

        <div className="login-footer">
          <p>&copy; 2025 SPHEROID. Powered by ESA Business Incubation.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
